export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

/**
 * Recorta e redimensiona a imagem para garantir performance e economia de storage.
 * @param {string} imageSrc - URL da imagem (DataURL ou BlobURL)
 * @param {object} pixelCrop - Coordenadas do corte {x, y, width, height}
 * @param {number} maxWidth - Largura máxima permitida para o resultado
 */
export default async function getCroppedImg(
  imageSrc,
  pixelCrop,
  maxWidth = 800,
) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) return null;

  // Calcula a escala para limitar o tamanho mantendo a proporção do corte
  const scale = Math.min(1, maxWidth / pixelCrop.width);
  const targetWidth = Math.floor(pixelCrop.width * scale);
  const targetHeight = Math.floor(pixelCrop.height * scale);

  canvas.width = targetWidth;
  canvas.height = targetHeight;

  // Desenha a área recortada da imagem original no canvas de destino (redimensionando)
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    targetWidth,
    targetHeight,
  );

  // Retorna como Blob (WebP para otimização)
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (file) => {
        if (file) {
          file.name = "cropped.webp";
          resolve(file);
        } else {
          reject(new Error("Canvas is empty"));
        }
      },
      "image/webp",
      0.8, // Qualidade otimizada para backgrounds
    );
  });
}
